/* 2026 homepage revamp: carousel dots, banner video controls and the social
   strip's progress bar. Each section is initialised once, and again when the
   theme editor reloads it. */
(function () {
  // Several sections include this file; only the first copy runs.
  if (window.homeRevampLoaded) return;
  window.homeRevampLoaded = true;

  function initCarousel(root) {
    var list = root.querySelector('[data-carousel-list]');
    var dots = root.querySelectorAll('[data-carousel-dot]');
    if (!list || !dots.length) return;

    function current() {
      return Math.round(list.scrollLeft / Math.max(list.clientWidth, 1));
    }

    function update() {
      var index = current();
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        list.scrollTo({ left: i * list.clientWidth, behavior: 'smooth' });
      });
    });
    list.addEventListener('scroll', update, { passive: true });
    update();
  }

  // Muted looping banner video with the PDP video's sound and pause buttons.
  function initVideo(root) {
    var video = root.querySelector('[data-home-video] video');
    var sound = root.querySelector('[data-video-sound]');
    var pause = root.querySelector('[data-video-pause]');
    if (!video || !sound || !pause) return;

    function syncPause() {
      pause.setAttribute('aria-pressed', String(video.paused));
      pause.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    }

    // Respect reduced motion: show the poster and let the viewer start it.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
      syncPause();
    }

    sound.addEventListener('click', function () {
      video.muted = !video.muted;
      sound.setAttribute('aria-pressed', String(!video.muted));
      sound.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Mute video');
    });

    pause.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', syncPause);
    video.addEventListener('pause', syncPause);
  }

  function initStrip(root) {
    var strip = root.querySelector('[data-strip]');
    var bar = root.querySelector('[data-strip-bar]');
    var thumb = root.querySelector('[data-strip-thumb]');
    if (!strip || !bar || !thumb) return;

    function update() {
      var overflow = strip.scrollWidth - strip.clientWidth;
      bar.hidden = overflow <= 1;
      if (overflow <= 1) return;
      var ratio = strip.clientWidth / strip.scrollWidth;
      var width = bar.clientWidth * ratio;
      thumb.style.width = width + 'px';
      thumb.style.transform = 'translateX(' + (strip.scrollLeft / overflow) * (bar.clientWidth - width) + 'px)';
    }

    // Mouse users can drag the strip; touch and trackpads scroll natively.
    var startX = 0;
    var startScroll = 0;
    var dragging = false;
    var moved = false;

    strip.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse') return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = strip.scrollLeft;
    });

    window.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) {
        moved = true;
        strip.classList.add('is-dragging');
      }
      strip.scrollLeft = startScroll - delta;
    });

    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      strip.classList.remove('is-dragging');
    });

    // A drag should not open the post it started on.
    strip.addEventListener('click', function (event) {
      if (moved) {
        event.preventDefault();
        moved = false;
      }
    }, true);

    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(scope) {
    scope.querySelectorAll('[data-home-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-home-strip]').forEach(initStrip);
    scope.querySelectorAll('.home-banner').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
